<template>
  <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="modal" @click="close"></div>
    <div class="modal-alert">
      <div class="title-close">
        <div class="title" style="margin-bottom: 0">更换服务商</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>

      <div class="tips">
        <!-- 1、更换的前提条件是当前任务包未结算；<br /> -->
        如果是非转派的包，当前任务包的所有任务执行人必须在新服务商公司存在，不存在则需要在新服务商先开通账号，无需重新备案；<br />
      </div>

      <el-form
        class="flex direction-column items-center"
        style="margin-right: 30px"
      >
        <el-form-item label="当前服务商: " label-width="100px">
          <el-popover trigger="hover" width="340" placement="right-start">
            <div>
              该服务商为配置任务包、派发任务包的服务商，不是三方接包服务商。
            </div>
            <template slot="reference">
              <i class="el-icon-question"></i>
            </template>
          </el-popover>
          {{ detail.serviceTenantName }}
        </el-form-item>
        <el-form-item label="接替服务商: " label-width="120px">
          <el-select
            v-model="formData.serviceTenantGuid"
            class="select-wrap"
            placeholder="请选择接替服务商"
            filterable
            @change="(val) => onChangeTenant(val)"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-form-item>
        <div :class="['errMsg', { warning: formData.isWarning }]">
          {{ formData.errMsg }}
        </div>
      </el-form>

      <div class="btns" @click="submit">确定</div>
      <div class="btns cancel" @click="close">取消</div>
    </div>
  </div>
</template>
<script>
import { ServiceProviderTypeEnum } from "../../mixins/getTenantDetail";
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      fullscreenLoading: false,
      tenantList: [],
      formData: {
        serviceTenantGuid: "",
        errMsg: "",
        isWarning: false,
      },
    };
  },
  created() {
    this.getTenantOperationRelList();
  },
  methods: {
    async onSubmit() {
      const userInfo = JSON.parse(localStorage.userInfo);
      const params = {
        guid: this.$route.query.guid,
        serviceTenantGuid: this.formData.serviceTenantGuid,
        serviceTenantName: this.serviceTenantName,
        staffGuid: userInfo.staffGuid,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/task-edit/service/update-service`,
          params
        )
        .finally(() => {
          this.fullscreenLoading = false;
        });
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.close();
    },
    async checkData() {
      const params = {
        guid: this.$route.query.guid,
        serviceTenantGuid: this.formData.serviceTenantGuid,
        serviceTenantName: this.serviceTenantName,
      };
      this.fullscreenLoading = true;
      const { data } = await this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/task-edit/service/check-update-service`,
          params
        )
        .finally(() => {
          this.fullscreenLoading = false;
        });
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      if (data.data) {
        this.formData.errMsg = data.data;
        // 如果文案包含"结算中"，不拦截，可以继续提交
        if (data.data.includes("结算中")) {
          this.formData.isWarning = true;
          return true;
        }
        this.formData.isWarning = false;
        return false;
      }
      this.formData.isWarning = false;
      return true;
    },
    async getTenantOperationRelList() {
      const query = {
        serviceProviderTypeList: [
          ServiceProviderTypeEnum.THIRD_PARTY_SASS,
          ServiceProviderTypeEnum.GENERAL_CONTRACTOR,
        ],
      };
      this.fullscreenLoading = true;
      const { data } = await this.api
        .postJson(
          `/${serverConfig.msCustomerService}/tenant-expand/service/get-list`,
          query
        )
        .finally(() => {
          this.fullscreenLoading = false;
        });
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.tenantList = data.data;
    },

    close() {
      this.$emit("close");
    },
    async onChangeTenant(val) {
      this.formData.serviceTenantGuid = val;
      this.formData.errMsg = "";
      // 选择服务商时就进行校验，提前展示警告文案
      if (val) {
        await this.checkData();
      }
    },
    //提交
    async submit() {
      if (!this.formData.serviceTenantGuid) {
        this.$message.error("请选择接替服务商");
        return;
      }

      const f = await this.checkData();
      if (!f) {
        return;
      }

      const res = await this.$confirm(
        "提交后，当前任务包请至接替的服务商查询，确定更换吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      );
      if (!res) {
        return;
      }
      this.onSubmit();
    },
  },
  computed: {
    serviceTenantName() {
      return this.tenantList.find(
        (item) => item.guid == this.formData.serviceTenantGuid
      ).name;
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: 0.3;
}

.modal-alert {
  position: fixed;
  width: 550px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}

.title-close div {
  height: 100%;
  line-height: 50px;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4fa1a4;
  border-radius: 2px;
  color: #fff;
  margin-top: 15px;
  float: right;
  margin-right: 20px;
  line-height: 28px;
  cursor: pointer;
}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #fffbf2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;
  color: red;
}

.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.direction-column {
  flex-direction: column;
}

.items-center {
  align-items: center;
}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4fa1a4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #f0f0f0 !important;
  padding: 10px 0;
  color: #323233;
  overflow-x: scroll;
}

/deep/ .el-table td {
  padding: 10px 0px;
}

/deep/.el-input-number__decrease {
  height: 33px;
  top: 3px;
}

/deep/ .el-input-number__increase {
  height: 33px;
  top: 3px;
}

.table-wrap {
  margin: 20px;
}

.btns.cancel {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color: #666;
}

.errMsg {
  color: #de4355;
  padding-left: 50px;
  line-height: 20px;
}

.errMsg.warning {
  color: #ff991c;
}
</style>
